import React, { Suspense, useState, useEffect } from 'react';
import { Button, Container, Spinner } from 'reactstrap';
import { Redirect, Route, Switch } from 'react-router-dom';
import CONSTANTS from 'utils/CONSTANTS';
import ViewTable from 'utils/ReactTableCards';
import {
  addSpeciality,
  deleteSpeciality,
  editSpeciality,
  getAllSpeciality,
} from 'utils/API/api';
import AddNewModalWithOutButton from 'components/advisor/add-new-Modal-with-out-button';
import IntlMessages from 'helpers/IntlMessages';
import AlertPopup from 'components/alert-popup';

const Speciality = ({ match }) => {
  const [specialityList, setSpecialityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [specialityData, setSpecialityData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteSpeciality = (clientId) => {
    setDeleteId(clientId);
    setIsConfirmationOpen(true);
  };

  const confirmDeleteSpeciality = async () => {
    if (deleteId) {
      const res = await deleteSpeciality(deleteId);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setIsConfirmationOpen(false);
      }
    }
  };

  const handleEditSpeciality = (editValue) => {
    if (editValue) {
      setSpecialityData({ ...editValue });
      setEditModalOpen(true);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await getAllSpeciality();
      if (res !== -1) {
        setSpecialityList(
          res?.data?.data.map((planItem, index) => {
            return {
              no: index + 1,
              ...planItem,
              deleteData: {
                buttonLabel: 'Delete',
                id: planItem?.id,
                onClick: handleDeleteSpeciality,
              },
              editData: {
                buttonLabel: 'Edit',
                id: {
                  ...planItem,
                  profilePic: '',
                },
                onClick: handleEditSpeciality,
              },
            };
          })
        );
      }
      setLoading(false);
    })();
  }, [refresh]);

  const prepareFormData = (e) => {
    const payload = {};
    console.log(e.target);
    CONSTANTS.RIGHT_SIDEBAR_FIELD.SPECIALITY_MODAL.forEach((field) => {
      const tempValue = e.target[field.name].value;
      if (tempValue) {
        payload[field.name] = tempValue;
      }
    });
    if (e.target?.image?.files && e.target?.image?.files[0]) {
      payload.image = e.target?.image?.files[0] || null;
    }
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });
    return formData;
  };

  const editSpecialityHandler = (e) => {
    e.preventDefault();
    (async () => {
      if (specialityData?.id) {
        const formData = prepareFormData(e);

        setLoading(true);
        const res = await editSpeciality(specialityData?.id, formData);
        if (res !== -1) {
          setRefresh((previous) => !previous);
          setEditModalOpen(!editModalOpen);
        }
        setLoading(false);
      }
    })();
  };

  const addSpecialityHandler = (e) => {
    e.preventDefault();
    (async () => {
      const formData = prepareFormData(e);

      setLoading(true);
      const res = await addSpeciality(formData);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setModalOpen(!modalOpen);
      }
      setLoading(false);
    })();
  };

  return (
    <Suspense fallback={<div className="loading" />}>
      <Switch>
        <Route
          path={`${match.url}`}
          exact
          render={() =>
            !loading ? (
              <>
                <Container
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    maxWidth: '100%',
                    margin: '0px',
                    padding: '0',
                    marginTop: '-10px',
                    marginBottom: '15px',
                    marginLeft: '-27px',
                  }}
                >
                  <Button
                    outline
                    color="primary"
                    className="top-right-button"
                    onClick={() => setModalOpen(true)}
                  >
                    <IntlMessages id={CONSTANTS.TABLE_ID.addSpeciality} />
                  </Button>
                </Container>
                <AddNewModalWithOutButton
                  sidebarMenu="SPECIALITY_MODAL"
                  dataId={CONSTANTS.TABLE_ID.add}
                  modalTitle={CONSTANTS.TABLE_ID.addSpeciality}
                  modalOpen={modalOpen}
                  toggleModal={() => setModalOpen(!modalOpen)}
                  onSubmit={addSpecialityHandler}
                  formData={{}}
                />

                <AddNewModalWithOutButton
                  sidebarMenu="SPECIALITY_MODAL"
                  modalTitle={CONSTANTS.TABLE_ID.editSpeciality}
                  modalOpen={editModalOpen}
                  toggleModal={() => setEditModalOpen(!editModalOpen)}
                  onSubmit={editSpecialityHandler}
                  formData={specialityData}
                />

                <ViewTable
                  headers={CONSTANTS.TABLE_HEADER.SPECIALITY_LIST}
                  items={specialityList}
                  advisorId={CONSTANTS.TABLE_ID.speciality}
                  filterParams="name"
                />

                <AlertPopup
                  isOpen={isConfirmationOpen}
                  positiveText="Yes"
                  negativeText="No"
                  warning="Are you sure you want to delete?"
                  onNegative={() => {
                    setIsConfirmationOpen(false);
                    setDeleteId(null);
                  }}
                  onPositive={confirmDeleteSpeciality}
                />
              </>
            ) : (
              <>
                <Container className="d-flex justify-content-center align-items-center">
                  <Spinner
                    animation="border"
                    className="d-inline-flex m-2 "
                    color="$theme-color-yellow-granola"
                  />
                </Container>
              </>
            )
          }
        />
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  );
};

export default Speciality;
